import './footer.css';

const Footer = () => {
    return (
        <footer>
            <a href='https://github.com/khaletska'>Visit my GitHub</a>
            <svg width="2" height="16" viewBox="0 0 1 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="0.5" x2="0.5" y2="16" stroke="#f5f5f5" />
            </svg>

            <a href='https://www.linkedin.com/in/elena-khaletska/'>Let's connect on LinkedIn!</a>
            <svg width="2" height="16" viewBox="0 0 1 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="0.5" x2="0.5" y2="16" stroke="#f5f5f5" />
            </svg>

            <a href='mailto:khaletska.e@gmail.com'>Write me an e-mail: khaletska.e@gmail.com</a>
            <svg width="2" height="16" viewBox="0 0 1 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <line x1="0.5" x2="0.5" y2="16" stroke="#f5f5f5" />
            </svg>

            <a href='tel:+3725501353'>Call me: +3725501353</a>
        </footer>
    )
}

export default Footer;